import MasterTablePage from '../components/MasterTablePage';
import { listSalesmenPage, createSalesman, updateSalesman, deleteSalesman, bulkUploadSalesmen } from '../api/salesmen';

const columns = [
  { key: 'salesmanCode', label: 'Code' },
  { key: 'salesmanName', label: 'Name' },
  { key: 'channel', label: 'Channel' },
];

const fields = [
  { name: 'salesmanCode', label: 'Salesman Code' },
  { name: 'salesmanName', label: 'Salesman Name' },
  { name: 'channel', label: 'Channel', required: false },
];

export default function SalesmanMaster() {
  return (
    <MasterTablePage
      title="Salesman Master"
      columns={columns}
      fields={fields}
      api={{
        list: listSalesmenPage,
        create: createSalesman,
        update: updateSalesman,
        remove: deleteSalesman,
        bulkUpload: bulkUploadSalesmen,
      }}
      uploadTemplateHint="Columns: salesmanCode, salesmanName, channel"
    />
  );
}
